module.exports = __webpack_public_path__ + "ed3777105a1e6b4d7bdd6618d2012f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/ALLEYESONUS_HEAD2.jpg
// module id = 614
// module chunks = 0